var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.95,
    height: 69.43,
    viewBox: "0 0 64.95 69.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.28,69.43h-9.01c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h9.01c2.77,0,5.03-2.25,5.03-5.03V17.69h-8.19c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h9.01c.46,0,.82.37.82.82v45.89c0,3.68-2.99,6.68-6.68,6.68Z",
    fill: "red",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.14,22.89c-.46,0-.82-.37-.82-.82v-9.99c0-5.75-4.68-10.42-10.42-10.42s-10.42,4.68-10.42,10.42v4.79c0,.46-.37.82-.82.82s-.82-.37-.82-.82v-4.79c0-6.66,5.42-12.07,12.07-12.07s12.07,5.42,12.07,12.07v9.99c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.22,22.89c-.46,0-.82-.37-.82-.82v-9.99c0-5.75-4.68-10.42-10.42-10.42s-10.42,4.68-10.42,10.42v9.99c0,.46-.37.82-.82.82s-.82-.37-.82-.82v-9.99C15.9,5.42,21.31,0,27.97,0s12.07,5.42,12.07,12.07v9.99c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.22,27.64c-1.75,0-3.17-1.42-3.17-3.17s1.42-3.17,3.17-3.17,3.17,1.42,3.17,3.17-1.42,3.17-3.17,3.17ZM39.22,22.94c-.84,0-1.52.68-1.52,1.52s.68,1.52,1.52,1.52,1.52-.68,1.52-1.52-.68-1.52-1.52-1.52Z",
    fill: "red",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72,27.64c-1.75,0-3.17-1.42-3.17-3.17s1.42-3.17,3.17-3.17,3.17,1.42,3.17,3.17-1.42,3.17-3.17,3.17ZM16.72,22.94c-.84,0-1.52.68-1.52,1.52s.68,1.52,1.52,1.52,1.52-.68,1.52-1.52-.68-1.52-1.52-1.52Z",
    fill: "red",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.97,59.28c-7.48,0-13.56-6.08-13.56-13.56s6.08-13.56,13.56-13.56,13.56,6.08,13.56,13.56-6.08,13.56-13.56,13.56ZM27.97,33.82c-6.57,0-11.91,5.34-11.91,11.91s5.34,11.91,11.91,11.91,11.91-5.34,11.91-11.91-5.34-11.91-11.91-11.91Z",
    fill: "red",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.97,53.98c-.46,0-.82-.37-.82-.82v-14.55c0-.46.37-.82.82-.82s.82.37.82.82v14.55c0,.46-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.24,46.7h-14.55c-.46,0-.82-.37-.82-.82s.37-.82.82-.82h14.55c.46,0,.82.37.82.82s-.37.82-.82.82Z",
    fill: "red",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.26,69.43H6.68c-3.68,0-6.68-3-6.68-6.68V16.86c0-.46.37-.82.82-.82h54.29c.46,0,.82.37.82.82v45.89c0,3.68-2.99,6.68-6.68,6.68ZM1.65,17.69v45.07c0,2.77,2.25,5.03,5.03,5.03h42.59c2.77,0,5.03-2.25,5.03-5.03V17.69H1.65Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerch);
export default __webpack_public_path__ + "static/media/merch.79409917e87eb0c714f4e3ef595e6269.svg";
export { ForwardRef as ReactComponent };